const WHATSAPP_BOLD = /\*(\S(?:.*?\S)?)\*/g
const WHATSAPP_ITALIC = /_(\S(?:.*?\S)?)_/g
const WHATSAPP_STRIKE = /~(\S(?:.*?\S)?)~/g
const AUTO_LINK_URL = /(https?:\/\/[^\s<]+)/g

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/**
 * Renders WhatsApp-style markers and auto-links http(s) URLs into safe HTML.
 */
export function formatGroupChatContent(content: string): string {
  let html = escapeHtml(content)
  html = html.replace(WHATSAPP_BOLD, '<strong>$1</strong>')
  html = html.replace(WHATSAPP_ITALIC, '<em>$1</em>')
  html = html.replace(WHATSAPP_STRIKE, '<s>$1</s>')
  html = html.replace(
    AUTO_LINK_URL,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  )
  return html
}
